import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: { margin: "0px" },
}));

export default useStyles;
